import React from 'react';
import { Time } from "components/Time/Time";

interface TimeLengthSettingsProps {
    object: any;
}

export const TimeLengthSettings: React.FC<TimeLengthSettingsProps> = ({ object }) => {
    return (
        <div className="col-12">
            <Time
                mode="edit"
                name="defaultValue"
                label="defaultValue"
                type="Time"
                defaultValue={object?.defaultValue}
            />
        </div>
    );
}; 